import { NewRole } from '../../type/entities/role-type';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/roles';

export class RoleService extends RestServiceConnection {

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN NUEVO ROL
     * @EN CREATES A NEW ROLE
     * 
     * @param role
     */
    //-------------------------------------------------------------------------------------------------------------
    createRole = async (role: NewRole) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: role,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN ROL
     * @EN UPDATES A ROLE
     * 
     * @param role
     */
    //-------------------------------------------------------------------------------------------------------------
    editRole = async (role: NewRole) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: role,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTA LOS ROLES
     * @EN LISTS THE ROLES
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listRoles = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN ROL POR ID
     * @EN GETS A ROLE BY ID
     * 
     * @param roleId
     */
    //-------------------------------------------------------------------------------------------------------------
    getRoleById = async (roleId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: roleId
             },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLES UN ROL
     * @EN TOGGLES A ROLE
     * 
     * @param roleId
     * @param active
     */
    //-------------------------------------------------------------------------------------------------------------
    toggleRoleStatus = async (roleId: string, active: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { 
                id: roleId, 
                active 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA LOS PERMISOS DE UN ROL
     * @EN EDITS THE PERMISSIONS OF A ROLE
     * 
     * @param role
     * @param company
     * @param permissions
     */
    //-------------------------------------------------------------------------------------------------------------
    editRolePermissions = async (role: string, company: string | null, permissions: number[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit-permissions',
            data: {
                id: role,
                company: company,
                permissions: permissions
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN ROL
     * @EN DELETES A ROLE
     * 
     * @param roleId
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteRole = async (roleId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: roleId 
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS ROLES
     * @EN DELETES MULTIPLE ROLES
     * 
     * @param roleIds
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteMultiRoles = async (roleIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { 
                ids: roleIds
             }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------


    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTA LOS ROLES
     * @EN LISTS THE ROLES
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listSelectRoles = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------
}